import { Injectable } from '@angular/core';
import {
  ProductConfiguration,
  ProductConfigurationFeature,
  ProductConfigurationOption
} from '../../models/product-configuration-types';
import { Product } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class CpqConfigService {
  /**
   * Feature property that must be true for the feature to render as a picker. Undefined renders every connected
   * feature. Hidden features still take part in rules, so options they auto select reach the order.
   */
  getFeatureVisibilityPropertyKey(): string | undefined {
    return undefined;
  }

  showQuantity(): boolean {
    return false;
  }

  /**
   * Gives every configured cart row its own partial id so two configurations of the same template stay two rows.
   */
  useProductPartialId(): boolean {
    return false;
  }

  getCartRowSummaryMode(): 'popover' | 'inline' {
    return 'popover';
  }

  /**
   * Route of the page hosting the configurator, e.g. '/concept'. When set, a configured cart row with a partial id
   * gets an Edit configuration link that reopens the configurator with the row's selection.
   */
  getEditConfigurationRoute(): string | undefined {
    return undefined;
  }

  /**
   * The options of a feature offered for the current selection. A selected option that is no longer offered is
   * removed from the selection.
   */
  getAvailableOptions(
    feature: ProductConfigurationFeature,
    options: ProductConfigurationOption[],
    selection: Map<string, ProductConfigurationOption[]>
  ): ProductConfigurationOption[] {
    return options;
  }

  addOnAsCheckbox(): boolean {
    return false;
  }

  /**
   * Hides features the configuration connects no options to, and they no longer block ordering.
   */
  hideFeaturesWithoutOptions(): boolean {
    return false;
  }

  /**
   * Option properties a SELECT feature with featurePresentation 'pills' is chosen by, one row of values each.
   */
  getPillProperties(): string[] {
    return ['width', 'height'];
  }

  /**
   * Renders a SELECT feature as a searchable single select dropdown instead of the browser's native select.
   */
  useDropdownSelect(feature: ProductConfigurationFeature): boolean {
    return false;
  }

  /**
   * Loads the products behind the options' materials when the configurator starts, for labels built from them.
   */
  loadMaterialProducts(): boolean {
    return false;
  }

  getOptionLabel(
    feature: ProductConfigurationFeature,
    option: ProductConfigurationOption,
    materialProducts: Map<string, Product>
  ): string {
    return option.name;
  }

  getOptionSubLabel(
    feature: ProductConfigurationFeature,
    option: ProductConfigurationOption,
    materialProducts: Map<string, Product>
  ): string | undefined {
    return undefined;
  }

  /**
   * Options selected when the configurator opens without a selection to restore, in the order they are applied.
   */
  getDefaultOptionIds(
    configuration: ProductConfiguration,
    features: ProductConfigurationFeature[],
    options: ProductConfigurationOption[]
  ): string[] {
    return [];
  }
}
